import { connect } from 'react-redux';

import WorklistHelp from './WorklistHelp.js';

const mapStateToProps = state => {
  return {};
};

const ConnectedWorklistHelp = connect(
  mapStateToProps,
  null
)(WorklistHelp);

export default ConnectedWorklistHelp;
